import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { allTenantDependentDataCleared, tenantSelected } from '../action/authenticationEvents';
import { Tenant } from '../api/types';

/**
 * The one way to switch into a tenant: the tenant dropdown (TenantSwitcher)
 * and the "Öffnen" action on the master page "Mandanten" both call this, so a
 * switch from either place sets the same state and lands on the same page.
 *
 * Every RTK Query cache is reset centrally whenever the tenant value changes
 * (`store/tenantCacheResetMiddleware`), so nothing is cleared by hand here.
 */
export const useSwitchTenant = (): ((newTenant: Tenant | null) => void) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return useCallback((newTenant: Tenant | null) => {
        dispatch(tenantSelected({ tenant: newTenant }));
        // An explicit tenant pick must land on the tenant's default page —
        // without the marker, the index route would send users with the
        // all-tenant view straight back to it (see DefaultLanding).
        navigate('/', { state: { skipMasterLanding: true } });
        dispatch(allTenantDependentDataCleared({}));
    }, [dispatch, navigate]);
};
